<template>
  <div class="NVF__Senior">
    <div class="NVF__Senior__header">
      <p class="NVF__Senior__header__p1">
        {{ $t('common-verify-flow.kyc_verify') }}
      </p>
      <p class="NVF__Senior__header__p2">{{ $t('common-verify-flow.b2') }}</p>
    </div>
    <div class="NVF__Senior__notice">
      {{ $t('common-verify-flow.starter-desc-3') }}
    </div>
    <!-- <TopNav /> -->
    <div class="NVF__Senior__Content">
      <div class="NVF__Senior__Content__center">
        <div class="NVF__Senior__Content__center__Qr" v-loading="isLoading">
          <qrcode
            class="NVF__Senior__Content__center__Qr_code"
            :value="qrcodeUrl"
            :options="{ width: 130, margin: 0 }"
          />
          <div
            class="NVF__Senior__Content__center__Qr_white-block NVF__Senior__Content__center__Qr_white-block-top"
          ></div>
          <div
            class="NVF__Senior__Content__center__Qr_white-block NVF__Senior__Content__center__Qr_white-block-left"
          ></div>
          <div
            class="NVF__Senior__Content__center__Qr_white-block NVF__Senior__Content__center__Qr_white-block-bottom"
          ></div>
          <div
            class="NVF__Senior__Content__center__Qr_white-block NVF__Senior__Content__center__Qr_white-block-right"
          ></div>
          <div class="NVF__Senior__Content__center__Qr_line"></div>
        </div>
        <p class="NVF__Senior__Content__tips" v-html="$t('common-verify-flow.tips_1')"></p>
      </div>
    </div>
    <div class="NVF__Senior__desc">
      {{ $t('common-verify-flow.tips_2') }}
    </div>
    <el-button type="primary" class="" @click="closeVerify">{{
      $t('common-verify-flow.senior-verify-done')
    }}</el-button>
  </div>
</template>

<script>
import { axiosClient } from '~/common/js/axios';
import { breakDownHostUrl } from '~/common/js/utils';
import Cookies from 'js-cookie';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import messages from '../i18n';
import { usePatchStore } from '~/common/js/patch';
export default {
  i18n: { messages },
  name: 'BmKycPage',
  layout: 'main-new',
  components: {
    qrcode: VueQrcode,
  },
  computed: {
    locale() {
      return this.store.locale;
    },
  },
  data() {
    return {
      isLoading: true,
      newHost: 'bitmart.com',
      qrcodeUrl: 'https://h5.bitmart.com/env/en?schema=jumio',
    };
  },
  mounted() {
    const host = window.location.host;
    let url = breakDownHostUrl(host);
    this.newHost = url;
    this.kycAdvancedApply();
  },
  methods: {
    async kycAdvancedApply() {
      // const token = Cookies.get('accessToken');
      const ret = await axiosClient({
        method: 'POST',
        url: '/gw-api/user-center/kyc/advanced/apply',
        // headers: {
        //   Authorization: token,
        // },
      });
      if (ret?.success) {
        this.qrcodeUrl = ret.data?.webHref;
        this.isLoading = false;
      }
    },
    closeVerify() {
      this.$emit('cancel')
    },
  },
  setup() {
    const { store } = usePatchStore();
    return {
      store,
    };
  }
};
</script>

<style lang="less">
.day-mode {
  --comp-verify-flow-dialog-senior-color-text: #1a1b1f;
  --comp-verify-flow-dialog-senior-color-text-400: #6a7c81;
  --comp-verify-flow-dialog-senior-color-text-300: #9cb3ba;
  --comp-verify-flow-dialog-senior-color-text-reverse: #ffffff;

  --comp-verify-flow-dialog-senior-color-bg: #fff;
  --comp-verify-flow-dialog-senior-color-bg-400: #fafafa;
  --comp-verify-flow-dialog-senior-color-bg-reverse: #383d4d;
}

.night-mode {
  --comp-verify-flow-dialog-senior-color-text: #ffffff;
  --comp-verify-flow-dialog-senior-color-text-400: #6a7c81;
  --comp-verify-flow-dialog-senior-color-text-300: #9cb3ba;
  --comp-verify-flow-dialog-senior-color-text-reverse: #1a1b1f;

  --comp-verify-flow-dialog-senior-color-bg: #2a2d37;
  --comp-verify-flow-dialog-senior-color-bg-400: #383d4d;
  --comp-verify-flow-dialog-senior-color-bg-reverse: #fafafa;
}
</style>
<style lang="less">
@import '~/common/css/element-base-type.less';
.NVF__Senior {
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;

  // :global {
  //   .sarterVerification-fade-enter-active {
  //     transition: opacity 0.5s;
  //   }
  //   .sarterVerification-fade-enter {
  //     opacity: 0;
  //   }
  // }
}

@keyframes qrcode {
  0% {
    top: 0;
  }
  50% {
    top: 100%;
  }
  100% {
    top: 0;
  }
}

@media (max-width: 768px) {
  .NVF__Senior {
    padding: 0 1em;
    &__header {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-end;
      margin-bottom: 10px;
      &__p1 {
        font-size: 1.5em;
        line-height: 1;
        color: var(--comp-verify-flow-dialog-senior-color-text, #1a1b1f);
        font-style: normal;
        font-weight: 600;
      }
      &__p2 {
        font-size: 0.7em;
        color: var(--comp-verify-flow-dialog-senior-color-text, #1a1b1f);
        font-weight: 500;
        line-height: 1;
        margin-left: 10px;
      }
    }
    &__notice {
      margin-top: 0.2em;
      font-style: normal;
      font-weight: 400;
      font-size: 0.7em;
      color: var(--comp-verify-flow-dialog-senior-color-text, #1a1b1f);
    }
    &__Content {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      margin-top: 1em;
      width: 100%;
      padding: 32px 0;
      background: var(--comp-verify-flow-dialog-senior-color-bg-400, #fafafa);

      border-radius: 0.2em;
      &__center {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        width: 12em;
        &__Qr {
          position: relative;
          height: 150px;
          &_code {
            padding: 7px;
            border: 3px solid #13c2c2;
            background: #fff;
          }
          &_white-block {
            width: 80%;
            height: 3px;
            background-color: #fff;
            position: absolute;
            &-top {
              top: 0;
              left: 50%;
              transform: translateX(-50%);
            }
            &-left {
              left: 0;
              top: 50%;
              width: 3px;
              height: 80%;
              transform: translateY(-50%);
            }
            &-bottom {
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);
            }
            &-right {
              right: 0;
              top: 50%;
              width: 3px;
              height: 80%;
              transform: translateY(-50%);
            }
          }
          &_line {
            position: absolute;
            width: 120%;
            height: 2px;
            top: 50px px;
            background-image: linear-gradient(
              to right,
              rgba(19, 194, 194, 0),
              rgba(19, 194, 194, 1),
              rgba(19, 194, 194, 0)
            );
            left: 50%;
            transform: translateX(-50%);
            animation: qrcode 3s linear 0s infinite;
          }
        }
      }
      &__tips {
        margin-top: 20px;
        width: 170px;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        color: var(--comp-verify-flow-dialog-senior-color-text-300, #9cb3ba);
        text-align: center;
      }
    }
    &__desc {
      margin: 26px 0 16px;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      display: flex;
      align-items: center;
      color: var(--comp-verify-flow-dialog-senior-color-text-300, #6a7c81);
      width: 100%;
    }
  }
}
@media (min-width: 768px) {
  .NVF__Senior {
    &__header {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-end;
      margin-bottom: 10px;
      &__p1 {
        font-size: 24px;
        line-height: 1;
        color: var(--comp-verify-flow-dialog-senior-color-text, #1a1b1f);
        font-style: normal;
        font-weight: bold;
      }
      &__p2 {
        margin-left: 10px;
        font-size: 14px;
        color: var(--comp-verify-flow-dialog-senior-color-text, #1a1b1f);
        font-weight: 500;
        line-height: 1;
      }
    }
    &__notice {
      margin-top: 8px;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: var(--comp-verify-flow-dialog-senior-color-text, #1a1b1f);
    }
    &__Content {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      margin-top: 20px;
      width: 100%;
      padding: 32px 0;
      background: var(--comp-verify-flow-dialog-senior-color-bg-400, #fafafa);

      border-radius: 4px;

      &__center {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        width: 12em;
        &__Qr__wrapper {
        }
        &__Qr {
          position: relative;
          height: 150px;
          &_code {
            padding: 7px;
            border: 3px solid #13c2c2;
            background-color: var(--comp-verify-flow-dialog-senior-color-bg, #fff);
          }
          &_white-block {
            width: 80%;
            height: 3px;
            background-color: var(--comp-verify-flow-dialog-senior-color-bg, #fff);
            position: absolute;
            &-top {
              top: 0;
              left: 50%;
              transform: translateX(-50%);
            }
            &-left {
              left: 0;
              top: 50%;
              width: 3px;
              height: 80%;
              transform: translateY(-50%);
            }
            &-bottom {
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);
            }
            &-right {
              right: 0;
              top: 50%;
              width: 3px;
              height: 80%;
              transform: translateY(-50%);
            }
          }
          &_line {
            position: absolute;
            width: 120%;
            height: 2px;
            top: 50px;
            background-image: linear-gradient(
              to right,
              rgba(19, 194, 194, 0),
              rgba(19, 194, 194, 1),
              rgba(19, 194, 194, 0)
            );
            left: 50%;
            transform: translateX(-50%);
            animation: qrcode 3s linear 0s infinite;
          }
        }
      }
      &__tips {
        margin-top: 20px;
        width: 170px;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        color: var(--comp-verify-flow-dialog-senior-color-text-300, #9cb3ba);
        text-align: center;
      }
    }
    &__desc {
      margin: 26px 0 16px;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      display: flex;
      align-items: center;
      color: var(--comp-verify-flow-dialog-senior-color-text-300, #9cb3ba);
      width: 100%;
    }
  }
}
</style>
